import { VIEW_PROJECT_ASSETS_DOWNLOAD } from "../constant/ActionType";

// shop.js passes `null` through on a failed request (auth/network error) — track
// that as `error` so the UI can distinguish "still loading" / "empty" / "failed".
export default function ProjectAssetsDownload_reducer(
    state = { data: [], masterData: null, error: false },
    action
) {
    switch (action.type) {
        case VIEW_PROJECT_ASSETS_DOWNLOAD: {
            if (!action.data) {
                return { ...state, error: true };
            }
            const res = action.data?.data;
            let items = [];
            let masterData = null;

            if (Array.isArray(res)) {
                items = res;
            } else if (res && typeof res === "object") {
                masterData = res;
                items = Array.isArray(res.existing_assets) ? res.existing_assets : [];
            }

            return { data: items, masterData, error: false };
        }
        default:
            return state;
    }
}
